const loading = (state) => state.datamaster.isLoading;
const datatmp = (state) => state.datamaster.getDataTmp;


const selectorMaster = {
    loading,
    datatmp,
};
export { selectorMaster };
